import { fmtFree, fmtAgo, destCities, nf } from "./liveTrucks";
import { codeSign, ORDER_TYPES, bodyTypeName, money, fmtDateShort } from "../loads/common";

/**
 * Content of the pop-up that opens when a map dot is clicked. Plain data (rendered with DOM nodes in
 * TrucksMap, never as HTML): { kind, title, sub, badge:{text,tone}, rows:[[label,value]], phone, actions:[{label,onClick}] }.
 */

const STATUS = {
  ACTIVE: { text: "Ищет груз", tone: "free" },
  BUSY: { text: "В рейсе", tone: "busy" },
  INACTIVE: { text: "Неактивна", tone: "idle" },
};

/** a live truck from `GET /m/trucks` (a driver's or a fleet's vehicle) */
export function truckInfo(t, { onRequest, sent, onDetails } = {}) {
  const dest = destCities(t);
  const rate = t.min_price ? `от ${nf(t.min_price)} ${codeSign(t.currency) || "сом"}` : "по договорённости";
  const w = t.max_load_weight ? `${nf(t.max_load_weight)} т` : null;
  const v = t.max_load_volume ? `${nf(t.max_load_volume)} м³` : null;
  return {
    kind: "truck",
    title: t.mark || "Машина",
    sub: [t.government_number, t.driver_name].filter(Boolean).join(" · "),
    badge: STATUS[t.status] || STATUS.ACTIVE,
    rows: [
      ["Кузов", [t.body_type_name, w, v].filter(Boolean).join(" · ") || "—"],
      ["Сейчас", [t.city, fmtAgo(t.confirmed_minutes_ago)].filter(Boolean).join(" · ") || "—"],
      ["Куда ищет", dest.length ? dest.join(", ") : "Любое направление"],
      ["Свободна", `${fmtFree(t)} · ${rate}`],
    ].filter(Boolean),
    actions: [
      ...(onRequest ? [{ label: sent ? "Заявка отправлена" : "Отправить заявку", disabled: !!sent, onClick: onRequest }] : []),
      ...(onDetails ? [{ label: "Детали транспорта", secondary: true, onClick: onDetails }] : []),
    ],
  };
}

/** an order from Django `/orders/` (pickup point on the map) */
export function loadInfo(o, { onRespond, done, onDetails } = {}) {
  const c = o.contacts || {};
  const dates = [fmtDateShort(o.from_date), o.to_date && o.to_date !== o.from_date ? fmtDateShort(o.to_date) : null].filter(Boolean);
  const price = money(o.price, o.currency);
  const w = o.item?.weight ? `${nf(o.item.weight)} т` : null;
  const v = o.item?.volume ? `${nf(o.item.volume)} м³` : null;
  return {
    kind: "load",
    title: `${o.from_address || "—"} → ${o.to_address || "—"}`,
    sub: [ORDER_TYPES[o.item?.type] || "Груз", bodyTypeName(o.transport_body_type)].filter((x) => x && x !== "—").join(" · "),
    badge: { text: o.distance || "Активен", tone: "free" },
    rows: [
      ["Вес / объём", [w, v].filter(Boolean).join(" / ") || "—"],
      ["Погрузка", dates.join(" — ") || "—"],
      ["Ставка", price || "по договорённости"],
      c.company_name || c.contact_name ? ["Заказчик", [c.company_name || c.contact_name, o.owner_type].filter(Boolean).join(" · ")] : null,
    ].filter(Boolean),
    phone: c.phone_number || null,
    actions: [
      ...(onRespond ? [{ label: done ? "Отклик отправлен" : "Откликнуться", disabled: !!done, onClick: onRespond }] : []),
      ...(onDetails ? [{ label: "Детали груза", secondary: true, onClick: onDetails }] : []),
    ],
  };
}
